import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "TumiProjectDarkRight" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "row pt-5 pb-5 align-items-center TumiProjectFrameRight",
  "data-aos": "fade-up"
}
const _hoisted_4 = { class: "col-sm-12 col-md-8 TumiMargin TumiColGauche TumiPictureFrame" }
const _hoisted_5 = {
  key: 0,
  width: "560",
  height: "315",
  src: "https://www.youtube.com/embed/D_sr0IRGnW4",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
  allowfullscreen: ""
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "col-sm-12 col-md-4 TumiTextFrameRight" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Check it on ")
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "TumiRound mt-5" }
const _hoisted_14 = { class: "col-sm-12 col-md-8 TumiMargin TumiColDroite TumiPictureFrame" }
const _hoisted_15 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.img)
            ? (_openBlock(), _createElementBlock("iframe", _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.img)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: require('@/assets/' + _ctx.img + '.png'),
                class: "img-fluid",
                alt: _ctx.img
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.title), 1),
          _createElementVNode("p", null, [
            _createElementVNode("span", { innerHTML: _ctx.text }, null, 8, _hoisted_9),
            (_ctx.link)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("a", {
                    href: 'http://' + _ctx.link
                  }, _toDisplayString(_ctx.link), 9, _hoisted_12)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.type), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.img)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require('@/assets/' + _ctx.img + '.png'),
                class: "img-fluid",
                alt: _ctx.img
              }, null, 8, _hoisted_15))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}